module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/house.svg?2cd0cc47cd50a6dcec5da1380570a923";